<fui-rows [formGroup]="formGroupContact">
    <fui-row *ngIf="!minimal">
        <fui-two-columns>
            <fui-column>
                <fui-prepend-field>
                    <wbo-single-select-edit-control formControlName="title" [(ngModel)]="contact.title"
                                                    [label]="'wbo.contact.edit.field.title.label'"
                                                    [placeholder]="'wbo.contact.edit.field.title.placeholder'">
                        <wbo-select-options>
                            <wbo-select-option label="wbo.contact.edit.option.title.mr"></wbo-select-option>
                            <wbo-select-option label="wbo.contact.edit.option.title.miss"></wbo-select-option>
                            <wbo-select-option label="wbo.contact.edit.option.title.mrs"></wbo-select-option>
                            <wbo-select-option label="wbo.contact.edit.option.title.ms"></wbo-select-option>
                            <wbo-select-option label="wbo.contact.edit.option.title.dr"></wbo-select-option>
                            <wbo-select-option label="wbo.contact.edit.option.title.prof"></wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                    <wbo-text-edit-control formControlName="firstName" [(ngModel)]="contact.firstName"
                                           [label]="'wbo.contact.edit.field.firstName.label'"
                                           [placeholder]="'wbo.contact.edit.field.firstName.placeholder'"></wbo-text-edit-control>
                </fui-prepend-field>
            </fui-column>
            <fui-column>
                <wbo-text-edit-control formControlName="lastName" [(ngModel)]="contact.lastName"
                                       [label]="'wbo.contact.edit.field.lastName.label'"
                                       [placeholder]="'wbo.contact.edit.field.lastName.placeholder'"></wbo-text-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row *ngIf="minimal">
        <fui-two-columns>
            <fui-column>
                <wbo-text-edit-control formControlName="firstName" [(ngModel)]="contact.firstName"
                                       [label]="'wbo.contact.edit.field.firstName.label'"
                                       [placeholder]="'wbo.contact.edit.field.firstName.placeholder'"></wbo-text-edit-control>
            </fui-column>
            <fui-column>
                <wbo-text-edit-control formControlName="lastName" [(ngModel)]="contact.lastName"
                                       [label]="'wbo.contact.edit.field.lastName.label'"
                                       [placeholder]="'wbo.contact.edit.field.lastName.placeholder'"></wbo-text-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row *ngIf="minimal">
        <fui-two-columns>
            <fui-column>
                <wbo-text-edit-control formControlName="email" [(ngModel)]="contact.email"
                                       [label]="'wbo.contact.edit.field.email.label'"
                                       [placeholder]="'wbo.contact.edit.field.email.placeholder'"></wbo-text-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>

    <fui-row *ngIf="!minimal">
        <fui-two-columns>
            <fui-column>
                <wbo-single-select-edit-control formControlName="gender" [(ngModel)]="contact.gender"
                                                [label]="'wbo.contact.edit.field.gender.label'"
                                                [placeholder]="'wbo.contact.edit.field.gender.placeholder'">
                    <wbo-select-options>
                        <wbo-select-option [value]="0"
                                           label="wbo.contact.edit.option.gender.male"></wbo-select-option>
                        <wbo-select-option [value]="1"
                                           label="wbo.contact.edit.option.gender.female"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
            </fui-column>
            <fui-column>
                <wbo-date-edit-control formControlName="dob" [(ngModel)]="contact.dob"
                                       [label]="'wbo.contact.edit.field.dob.label'"
                                       [placeholder]="'wbo.contact.edit.field.dob.placeholder'"></wbo-date-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row *ngIf="!minimal">
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-text-edit-control formControlName="mobilePhone" [(ngModel)]="contact.mobilePhone"
                                           [label]="'wbo.contact.edit.field.mobilePhone.label'"
                                           [placeholder]="'wbo.contact.edit.field.mobilePhone.placeholder'"></wbo-text-edit-control>
                    <wbo-text-edit-control formControlName="homePhone" [(ngModel)]="contact.homePhone"
                                           [label]="'wbo.contact.edit.field.homePhone.label'"
                                           [placeholder]="'wbo.contact.edit.field.homePhone.placeholder'"></wbo-text-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <fui-tandem-field>
                    <wbo-text-edit-control formControlName="workPhone" [(ngModel)]="contact.workPhone"
                                           [label]="'wbo.contact.edit.field.workPhone.label'"
                                           [placeholder]="'wbo.contact.edit.field.workPhone.placeholder'"></wbo-text-edit-control>
                    <wbo-text-edit-control formControlName="fax" [(ngModel)]="contact.fax"
                                           [label]="'wbo.contact.edit.field.fax.label'"
                                           [placeholder]="'wbo.contact.edit.field.fax.placeholder'"></wbo-text-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row *ngIf="!minimal">
        <fui-two-columns>
            <fui-column>
                <fui-append-field>
                    <wbo-text-edit-control formControlName="email" [(ngModel)]="contact.email"
                                           [label]="'wbo.contact.edit.field.email.label'"
                                           [placeholder]="'wbo.contact.edit.field.email.placeholder'"></wbo-text-edit-control>
                    <wbo-checkbox-edit-control formControlName="optedOutCommunications"
                                               [(ngModel)]="contact.optedOutCommunications"
                                               [label]="'wbo.contact.edit.field.optedOutCommunications.label'"></wbo-checkbox-edit-control>
                </fui-append-field>
            </fui-column>
            <fui-column>
                <wbo-location-single-select-edit-control formControlName="outletGroupId" [(ngModel)]="contact.outletGroupId"
                                                         [label]="'wbo.contact.edit.field.outletGroupId.label'"
                                                         [placeholder]="'wbo.contact.edit.field.outletGroupId.placeholder'"></wbo-location-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row *ngIf="!minimal">
        <fui-two-columns>
            <fui-column [label]="'wbo.contact.edit.field-set.homeAddress'" formGroupName="homeAddress">
                <wbo-address-edit [formGroupAddress]="formGroupContact.controls['homeAddress']"
                                  [address]="contact.homeAddress"></wbo-address-edit>
            </fui-column>
            <fui-column [label]="'wbo.contact.edit.field-set.postalAddress'" formGroupName="postalAddress">
                <wbo-address-edit [formGroupAddress]="formGroupContact.controls['postalAddress']"
                                  [address]="contact.postalAddress"></wbo-address-edit>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
